import {
  DEFAULT_ORGANIZATION_TIMEZONE,
  dateOnlyInTimezone,
  formatDateOnlyDisplay,
} from "../../../../../../../../../../../../_shared/_logic/timezones"

const deadlineWeeks = [3, 4, 5, 6, 7, 8, 12] as const
type DeadlineWeeks = (typeof deadlineWeeks)[number]
export type PlanningDueDatePreset = `in_${DeadlineWeeks}_weeks` | "custom"

export const defaultPlanningDueDate = (
  now = new Date(),
  timezone = DEFAULT_ORGANIZATION_TIMEZONE,
): string => dueDateInWeeks(6, now, timezone)

/** Calendar weeks from the organization's current date, independent of planning lead time. */
const dueDateInWeeks = (weeks: DeadlineWeeks, now: Date, timezone: string): string => {
  const today = dateOnlyInTimezone(now, timezone)

  if (!today) return ""

  const deadline = new Date(`${today}T00:00:00Z`)
  deadline.setUTCDate(deadline.getUTCDate() + weeks * 7)

  return deadline.toISOString().slice(0, 10)
}

export const planningDueDatePresetOptions = (
  now = new Date(),
  timezone = DEFAULT_ORGANIZATION_TIMEZONE,
): Array<{ label: string; value: PlanningDueDatePreset; dueDate: string | null }> => [
  ...deadlineWeeks.map((weeks) => {
    const dueDate = dueDateInWeeks(weeks, now, timezone)

    return {
      label: `In ${weeks} Wochen (${formatDateOnlyDisplay(dueDate)})`,
      value: `in_${weeks}_weeks` as PlanningDueDatePreset,
      dueDate,
    }
  }),
  { label: "Individuelles Fristdatum", value: "custom", dueDate: null },
]
